export function EcosystemDiagram() {
  return `
    <div class="ecosystem-wrap">
      <div class="ecosystem-diagram" aria-label="Diagrama del ecosistema de productos GR SoftMedia">
        <div class="ecosystem-lines" aria-hidden="true"><i></i><i></i><i></i><i></i></div>
        <div class="ecosystem-node node-project"><span>Proyectos</span><strong>InnoProject</strong><small>Planifica y controla</small></div>
        <div class="ecosystem-node node-capture"><span>Captura</span><strong>InnoCapture</strong><small>Registra información</small></div>
        <div class="ecosystem-center"><img src="/assets/gr-softmedia-mark-crop.png" alt="" width="474" height="474" loading="lazy" /><strong>Una sola visión</strong><span>Datos · autenticación · integraciones</span></div>
        <div class="ecosystem-node node-admin"><span>Operación</span><strong>InnoAdmin</strong><small>Administra y factura</small></div>
        <div class="ecosystem-node node-ecf"><span>e-CF</span><strong>Inno e-CF</strong><small>Procesa facturación</small></div>
      </div>
      <div class="ecosystem-notes">
        <div><span>01</span><p><strong>La información nace donde ocurre.</strong> Proyectos, gastos e incidencias se registran en el producto adecuado.</p></div>
        <div><span>02</span><p><strong>Los procesos continúan conectados.</strong> Administración y facturación reciben datos sin repetir trabajo manual.</p></div>
        <div><span>03</span><p><strong>Las integraciones amplían el ecosistema.</strong> Los productos pueden comunicarse con sistemas existentes.</p></div>
      </div>
    </div>
  `;
}
